import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  newNotification: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.data = action.payload;
    },
    clearNewNotification: (state) => {
      state.newNotification = false;
    },
    setNewNotificationTrue: (state) => {
      state.newNotification = true;
    },
    addNotification: (state, action) => {
      state.data = [action.payload, ...state.data];
    },
    addNotifications: (state, action) => {
      state.data = [...state.data, ...action.payload];
    },
  },
});

export const { setNotifications, clearNewNotification, setNewNotificationTrue, addNotification, addNotifications } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
